import { render, staticRenderFns } from "./app-bar.vue?vue&type=template&id=55c3a490&scoped=true"
import script from "./app-bar.vue?vue&type=script&lang=js"
export * from "./app-bar.vue?vue&type=script&lang=js"
import style0 from "./app-bar.vue?vue&type=style&index=0&id=55c3a490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c3a490",
  null
  
)

export default component.exports